const WOOD_RULES = {
  Furu: {
    defaultOil: "Brun",
    allowedOils: ["Naturell", "Brun", "Mörkbrun"]
  },

  Valnöt: {
    defaultOil: "Naturell",
    allowedOils: ["Naturell"]
  }
};

const WALL_MESSAGES = {
  Gips: "✓ Medföljer: Gipsexpandrar och skruvar för montering i gipsskivor.",
  Betong: "✓ Medföljer: Betongpluggar och skruvar för montering i betongvägg.",
  Tegel: "✓ Medföljer: Pluggar och skruvar anpassade för montering i tegelvägg.",
  Trä: "✓ Medföljer: Träskruvar för montering i trä."
};

const LEATHER_MESSAGES = {
  Ljusbrun: "✓ Ljusbrunt läder ger ett ljust och naturligt uttryck.",
  Brun: "✓ Brunt läder ger ett varmt och klassiskt uttryck.",
  Svart: "✓ Svart läder ger ett mörkt och kraftfullt uttryck."
};

class OakrynConfigurator {
  constructor() {
    document.addEventListener(
      "change",
      this.handleChange.bind(this)
    );

    this.updateOilOptions();
    this.updateLeatherMessage();
    this.updateWallMessage();
  }

  handleChange(event) {
    if (event.target.matches("[data-leather-color]")) {
      this.updateLeatherMessage();
      return;
    }

    if (event.target.matches("[data-wall-type]")) {
      this.updateWallMessage();
      return;
    }

    if (event.target.matches("[data-oil-finish]")) {
      this.updateHiddenOilValue(event.target.value);
      return;
    }

    const variantSelects = document.querySelector("variant-selects");

    if (!variantSelects || !variantSelects.contains(event.target)) {
      return;
    }

    window.setTimeout(() => this.updateOilOptions(), 0);
    window.setTimeout(() => this.updateOilOptions(), 150);
    window.setTimeout(() => this.updateOilOptions(), 350);
  }

  getSelectedWood() {
    const variantSelects = document.querySelector("variant-selects");

    if (!variantSelects) return null;

    const options = variantSelects.getAllSelectedOptions();

    const wood = options.find(
      option => option.name === "Träslag"
    );

    return wood ? wood.value : null;
  }

  getSelectedLeatherColor() {
    const selected = document.querySelector(
      "[data-leather-color]:checked"
    );

    return selected ? selected.value : "Brun";
  }

  getSelectedWallType() {
    const selected = document.querySelector(
      "[data-wall-type]:checked"
    );

    return selected ? selected.value : "Betong";
  }

  updateHiddenOilValue(value) {
    const hiddenInput = document.getElementById("oakryn-oil-value");

    if (hiddenInput) {
      hiddenInput.value = value;
    }
  }

  updateLeatherMessage() {
    const message = document.querySelector("[data-leather-message]");

    if (!message) return;

    const leatherColor = this.getSelectedLeatherColor();

    message.textContent = LEATHER_MESSAGES[leatherColor] || "";
  }

  updateWallMessage() {
    const message = document.querySelector("[data-wall-message]");

    if (!message) return;

    const wallType = this.getSelectedWallType();

    message.textContent = WALL_MESSAGES[wallType] || "";
  }

  updateOilOptions() {
    const wood = this.getSelectedWood();
    const rules = WOOD_RULES[wood];

    if (!rules) return;

    const oilContainer = document.querySelector(
      ".oakryn-product-options"
    );

    if (!oilContainer) return;

    const oilGroup = oilContainer.querySelector("fieldset");
    const oilMessage = oilContainer.querySelector("[data-oil-message]");

    const oilInputs = Array.from(
      oilContainer.querySelectorAll("[data-oil-finish]")
    );

    if (!oilInputs.length) return;

    const singleFinish = rules.allowedOils.length === 1;

    oilInputs.forEach(input => {
      const allowed = rules.allowedOils.includes(input.value);

      input.disabled = !allowed;
      input.checked = false;

      const label = oilContainer.querySelector(
        `label[for="${input.id}"]`
      );

      if (label) {
        label.style.display = allowed ? "" : "none";
      }
    });

    const defaultInput = oilInputs.find(
      input => input.value === rules.defaultOil
    );

    if (defaultInput) {
      defaultInput.disabled = false;
      defaultInput.checked = true;
    }

    this.updateHiddenOilValue(rules.defaultOil);

    if (oilGroup) {
      oilGroup.style.display = singleFinish ? "none" : "";
    }

    if (oilMessage) {
      oilMessage.style.display = singleFinish ? "block" : "none";
      oilMessage.textContent = singleFinish
        ? "✓ Valnöt levereras alltid med naturlig oljefinish."
        : "";
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new OakrynConfigurator();
});